<template>
  <div class="bg-book-demo h-100 p-3">
    <div class="container h-100" style="position: relative; z-index: 1">
      <div class="row h-100 box-center">
        <div class="col-12 col-lg-7 text-start d-none" style="font-size: 40px">
          <h1 class="fw-bolder" style="color: #265054">
            Begin your net zero<br />
            journey with us.
          </h1>
          <h1 class="my-4 fw-normal" style="color: #265054">
            Carbon accounting<br />
            with Carbonwize.
          </h1>
          <!-- <button class="btn btn-org mt-3" :disabled="loading" @click="startBuild">
                Get Started
                <i v-if="loading" class="fa-solid fa-circle-notch fa-spin"></i>
              </button> -->
        </div>
        <div
          class="col-12 form-height"
          style="
            text-align: left;
            background: white;
            box-shadow: 0px 4px 24px 0px #0000001a;
            padding: 18px;
            border-radius: 8px;
          "
        >
          <div class="row">
            <div class="col-12 col-md-6 padding-container">
              <label for="firstname" class="label">First name</label>
              <input
                v-model="form.firstname"
                class="form-control"
                type="text"
                placeholder="Firstname"
              />
              <span
                v-if="
                  validationStatus == false &&
                  v$.form.firstname.required.$invalid
                "
                class="error-text"
              >
                Please enter your First name
              </span>
            </div>
            <div class="col-12 col-md-6 padding-container">
              <label for="lastname" class="label">Last name</label>
              <input
                v-model="form.lastname"
                class="form-control"
                type="text"
                placeholder="Lastname"
              />
              <span
                v-if="
                  validationStatus == false &&
                  v$.form.lastname.required.$invalid
                "
                class="error-text"
              >
                Please enter your Last name
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 padding-container">
              <label for="company name" class="label">Company name</label>
              <input
                v-model="form.company"
                class="form-control"
                type="text"
                placeholder="Company name"
              />
              <span
                v-if="
                  validationStatus == false && v$.form.company.required.$invalid
                "
                class="error-text"
              >
                Please enter your Company name
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 padding-container">
              <label for="industry" class="label"
                >What industry are you in ?</label
              >
              <select
                v-model="form.industry"
                class="form-select"
                id="industry"
                aria-label="Floating label select example"
              >
                <option disabled value="">What industry are you in ?</option>
                <option
                  v-for="(industry, index) of industryData"
                  :key="index"
                  :value="industry"
                >
                  {{ industry }}
                </option>
              </select>
              <span
                v-if="
                  validationStatus == false &&
                  v$.form.industry.required.$invalid
                "
                class="error-text"
              >
                Please enter your Industry
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 padding-container">
              <label for="email" class="label">Email</label>
              <input
                v-model="form.email"
                class="form-control"
                type="text"
                placeholder="Email"
              />
              <span
                v-if="
                  validationStatus == false && v$.form.email.required.$invalid
                "
                class="error-text"
              >
                Please enter your Email
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 padding-container">
              <label for="phone-number" type="text" class="label"
                >Phone number</label
              >
              <vue-phone-number-input
                v-model="form.phone"
                color="dodgerblue"
                clearable
                :error="hasErrorActive"
                default-country-code="TH"
              />
              <span
                v-if="
                  validationStatus == false && v$.form.phone.required.$invalid
                "
                class="error-text"
              >
                Please enter your Phone number
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 padding-container">
              <label for="message" class="label">Leave a message for us</label>
              <input
                v-model="form.message"
                class="form-control"
                type="text"
                placeholder="Your message"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 padding-container">
              <label for="reference" class="label"
                >Reference code (Optional)</label
              >
              <input
                v-model="form.reference"
                class="form-control"
                type="text"
                placeholder="Reference code"
              />
              <!-- <span
                v-if="
                  validationStatus == false &&
                  v$.form.reference.required.$invalid
                "
                class="error-text"
              >
                Please enter your Reference code
              </span> -->
            </div>
          </div>
          <div class="row d-flex justify-content-center align-items-center">
            <button
              class="btn btn-submit-demo mt-3"
              @click="submitRequestBookDemo()"
            >
              Request for demo
            </button>
          </div>
          <!-- <img src="@/assets/headerpic.png" class="mw-100" alt="" /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Industry from "@/assets/industry.json";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { apiURL } from "@/configs/serverConfig";
import axios from "axios";
export default {
  components: {
    VuePhoneNumberInput,
  },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      hasErrorActive: false,
      form: {
        firstname: "",
        lastname: "",
        company: "",
        industry: "",
        email: "",
        phone: "",
        message: "",
        reference: "",
      },
      industryData: Industry.industry,
      validationStatus: true,
    };
  },
  validations() {
    return {
      form: {
        firstname: { required },
        lastname: { required },
        company: { required },
        industry: { required },
        email: { required },
        phone: { required },
      },
    };
  },
  methods: {
    async submitRequestBookDemo() {
      let isValidate = await this.v$.$validate();
      if (isValidate) {
        const url = `${apiURL}/demo_book`;
        const _data = {
          first_name: this.form.firstname,
          last_name: this.form.lastname,
          company_name: this.form.company,
          industry: this.form.industry,
          email: this.form.email,
          phone_number: this.form.phone,
          message: this.form.message,
          ref_code: this.form.reference,
        };

        try {
          const demo = await axios.post(url, _data);
          if (demo) {
            this.$router.push("/thankyou");
          }
        } catch (err) {
          this.$toast.error(err.response.data.message);
        }
      } else {
        this.validationStatus = false;
      }
    },
  },
};
</script>
<style lang="scss">
.bg-book-demo {
  background-image: url("../assets/bg-book-demo.png");
  background-size: cover;
  background-repeat: no-repeat;
  max-width: 100%;
  min-height: 100vh;
  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.box-center {
  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.form-height {
  @media (min-width: 768px) {
    min-height: 90vh;
  }
}

.label {
  color: #265054;
}

.padding-container {
  padding: 6px;
}

.btn-submit-demo {
  box-shadow: 0px 4px 24px 0px #00000033;
  background: linear-gradient(96.14deg, #25cf7a -0.88%, #0e713f 104.21%);
  color: white;
  max-width: 180px;
  @media (max-width: 767.98px) {
    margin-bottom: 2em;
  }
}
</style>
